import { Injectable } from '@angular/core';
import { Availability, AvailabilityHelperService, Product, STOCK_STATUS } from 'gung-standard';

@Injectable({
  providedIn: 'root'
})
export class CultAvailabilityHelperService extends AvailabilityHelperService {
  protected expectedDateArticleCategory = '102';

  protected getValueFromStatus(
    status: STOCK_STATUS,
    isSales: boolean,
    availability: Availability,
    product?: Product
  ): string {
    let value: string;

    if (!this.roles.includes('SHOW_ONLY_RETURNS')) {
      if (!availability) {
        value = '';
        return;
      }

      if (isSales) {
        if (status === STOCK_STATUS.IN_STOCK) {
          let avValue = availability.currentAvailability + '';
          if (availability.currentAvailability > 500 && product?.extra.ar?.q_eliasson_artnr !== '50') {
            avValue = '500+';
          }
          value = `${this.translateService.instant('IN_STOCK')} (${avValue})`;
        } else if (status === STOCK_STATUS.INCOMING) {
          const firstDate = Object.keys(availability.extra.availabilities).filter(key => {
            return availability.extra.availabilities[key] > 0;
          })[0];
          if (availability.maxFutureStock < 1000) {
            value =
              this.translateService.instant('EXPECTED_DATE', { date: firstDate }) +
              ' (' +
              availability.maxFutureStock.toString() +
              ')';
          } else {
            value = this.translateService.instant('EXPECTED_DATE', { date: firstDate }) + ' (' + '999' + ')';
          }
        }
      } else {
        if (status === STOCK_STATUS.IN_STOCK) {
          // const stock: string = availability.currentStock > 50 ? '50+' : Strinvalue = this.translateService.instant('EXPECTED_DATE', { date: firstDate})g(availability.currentStock);
          value = this.translateService.instant('IN_STOCK');
        } else if (status === STOCK_STATUS.INCOMING) {
          const firstDate = this.getExpectedDate(availability);
          if (String(product?.extra?.ar?.artkat ?? '').trim() === this.expectedDateArticleCategory && firstDate) {
            value = this.translateService.instant('EXPECTED_DATE', { date: firstDate });
          } else {
            value = this.translateService.instant('INCOMING');
          }
        }
      }
      if (status === STOCK_STATUS.OUT_OF_STOCK) {
        value = this.translateService.instant('OUT_OF_STOCK');
      }
    } else {
      value = '';
    }
    return value;
  }
}
